const INBOX_KEYS = {
  ERROR: 'error',
};

export { INBOX_KEYS };
